module.exports = __webpack_public_path__ + "static/img/sorrow1.65d7c29f.png";